module.exports = __webpack_public_path__ + "static/media/yoor_door_1.a7b00149.svg";